export const dashboardKeys = {
  root: ['dashboard'],
  stats: () => ['dashboard', 'stats'],
  overview: (params = {}) => ['dashboard', 'overview', params],
  summary: (params = {}) => ['dashboard', 'summary', params],
  charts: (params = {}) => ['dashboard', 'charts', params],
  recentActivity: (params = {}) => ['dashboard', 'recentActivity', params],
  preferences: () => ['dashboard', 'preferences'],
};

export const auditLogKeys = {
  root: ['auditLogs'],
  list: (params = {}) => ['auditLogs', 'list', params],
};

export const invoiceKeys = {
  root: ['invoices'],
  list: () => ['invoices', 'list'],
  detail: (id) => ['invoices', 'detail', id],
};

export const quotationKeys = {
  root: ['quotations'],
  list: () => ['quotations', 'list'],
  detail: (id) => ['quotations', 'detail', id],
};

export const estimatedInvoiceKeys = {
  root: ['estimatedInvoices'],
  list: () => ['estimatedInvoices', 'list'],
  detail: (id) => ['estimatedInvoices', 'detail', id],
};

export const productKeys = {
  root: ['products'],
  list: () => ['products', 'list'],
  detail: (id) => ['products', 'detail', id],
};

export const customerKeys = {
  root: ['customers'],
  list: () => ['customers', 'list'],
  detail: (id) => ['customers', 'detail', id],
};

export const taxKeys = {
  root: ['taxes'],
  list: () => ['taxes', 'list'],
};

export const settingsKeys = {
  root: ['settings'],
  profile: () => ['settings', 'profile'],
  designPreferences: () => ['settings', 'designPreferences'],
  visibilityPreferences: () => ['settings', 'visibilityPreferences'],
  showcase: () => ['settings', 'showcase'],
  ai: () => ['settings', 'ai'],
};

export const copilotKeys = {
  root: ['copilot'],
  config: () => ['copilot', 'config'],
  threads: () => ['copilot', 'threads'],
  thread: (threadId) => ['copilot', 'thread', threadId],
  run: (runId) => ['copilot', 'run', runId],
};

export const reportKeys = {
  root: ['reports'],
  salesBook: () => ['reports', 'salesBook'],
  hsnSummary: () => ['reports', 'hsnSummary'],
  taxLiability: () => ['reports', 'taxLiability'],
  agingSummary: () => ['reports', 'agingSummary'],
};

export const paymentKeys = {
  root: ['payments'],
  list: (params = {}) => ['payments', 'list', params],
};

export const customerPortalKeys = {
  root: ['customerPortal'],
  companies: () => ['customerPortal', 'companies'],
  overview: () => ['customerPortal', 'overview'],
  documents: (params = {}) => ['customerPortal', 'documents', params],
  documentDetail: (type, id) => ['customerPortal', 'document', type, id],
  documentHistory: (type, id) => ['customerPortal', 'documentHistory', type, id],
  planner: (params = {}) => ['customerPortal', 'planner', params],
  plannerSettings: () => ['customerPortal', 'plannerSettings'],
};

export const campaignKeys = {
  root: ['campaigns'],
  templates: () => ['campaigns', 'templates'],
  listRoot: () => ['campaigns', 'list'],
  list: (params = {}) => ['campaigns', 'list', params],
  detail: (id) => ['campaigns', 'detail', id],
  deliveries: (campaignId) => ['campaigns', 'deliveries', campaignId],
};

export const documentLayoutKeys = {
  root: ['documentLayouts'],
  list: (params = {}) => ['documentLayouts', 'list', params],
  detail: (id) => ['documentLayouts', 'detail', id],
  preview: (params = {}) => ['documentLayouts', 'preview', params],
};

export const documentLayoutAssetKeys = {
  root: ['documentLayoutAssets'],
  list: () => ['documentLayoutAssets', 'list'],
  detail: (id) => ['documentLayoutAssets', 'detail', id],
};

export const documentFormLayoutKeys = {
  root: ['documentFormLayouts'],
  list: (params = {}) => ['documentFormLayouts', 'list', params],
  detail: (id) => ['documentFormLayouts', 'detail', id],
  preferences: () => ['documentFormLayouts', 'preferences'],
};

export const fieldControllerKeys = {
  root: ['fieldController'],
  catalog: (params = {}) => ['fieldController', 'catalog', params],
  preferences: (params = {}) => ['fieldController', 'preferences', params],
};

export const customFieldKeys = {
  root: ['customFields'],
  definitions: (params = {}) => ['customFields', 'definitions', params],
  catalog: (params = {}) => ['customFields', 'catalog', params],
};

export const documentDeliveryKeys = {
  root: ['documentDeliveries'],
  latest: (documentType, documentId) => ['documentDeliveries', 'latest', documentType, documentId],
};
